import { useState } from 'react'
import { GameFilterOptionType, GamesFilterOptions } from './config'

const useGamesFilter = (defaultType?: GameFilterOptionType) => {
  const [selectedFilterType, setSelectedFilterType] = useState<GameFilterOptionType | null>(
    defaultType || GamesFilterOptions[0],
  )

  const onSelectOption = (option: GameFilterOptionType) => {
    setSelectedFilterType(option)
  }

  return {
    selectedFilterType,
    onSelectOption,
  }
}

export default useGamesFilter
